export default {
  FAQ_SEARCH_BOX: 'how-can-we-help',
  EVENTS_SEARCH_BOX: 'congresses-events',
  DATE_RANGE_PICKER_FROM: 'from-date',
  DATE_RANGE_PICKER_TO: 'to-date'
}
